import type { VerificationStatus } from '../types';
import { canPublishWithoutEmailVerification } from './can-publish-without-email-verification.util';

export type EmailPublishGate = 'allow' | 'pending' | 'block';

/**
 * `pending` means a signed-in profile has no verification status yet.
 * After a failed load the composer stays available and the server refusal
 * opens the same dialog.
 */
export function resolveEmailPublishGate(
  status: VerificationStatus | null | undefined,
  isProfileLoading: boolean,
  hasProfile: boolean,
  profileError: string | null = null,
): EmailPublishGate {
  const statusUnknown = status == null;
  const waitingForProfile = isProfileLoading || !hasProfile;
  if (statusUnknown && !profileError && waitingForProfile) return 'pending';
  if (!canPublishWithoutEmailVerification(status)) return 'block';
  return 'allow';
}
